import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useSectionNav } from "@/lib/scroll";

const links = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const sectionNav = useSectionNav();

  const go = (id) => {
    setOpen(false);
    sectionNav(id);
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-md border-b border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="font-heading text-lg sm:text-xl font-medium tracking-tight text-zinc-950 text-left leading-tight"
        >
          Saurabh <span className="text-zinc-500">Decor Creations</span>
        </button>

        <nav className="hidden lg:flex items-center gap-9" data-testid="nav-menu">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-zinc-600 hover:text-zinc-950 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("contact")}
            className="hidden sm:inline-flex items-center bg-zinc-950 text-white text-sm font-medium px-6 py-2.5 rounded-sm hover:bg-zinc-800 transition-colors duration-300"
          >
            Get a Free Quote
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-zinc-950 p-1"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-white border-t border-zinc-200 px-6 py-6 flex flex-col gap-5"
        >
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-base font-medium text-zinc-700 hover:text-zinc-950 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-quote-btn"
            onClick={() => go("contact")}
            className="mt-2 bg-zinc-950 text-white text-sm font-medium px-6 py-3 rounded-sm hover:bg-zinc-800 transition-colors duration-300"
          >
            Get a Free Quote
          </button>
        </div>
      )}
    </header>
  );
}
